// Define all constants for send flow here
export const quoteFeeRequestDefaults = {
  serviceOptionCode: "WILL_CALL",
  currencyCode: "USD",
  fundInStore: true,
  sendAmountIncludingFee: false,
  defaultSendAmount: 1,
};

export const mapiSenderAddressFields = {
  senderAddressline1: "sender.address.line1",
  senderAddressline2: "sender.address.line2",
  senderAddressline3: "sender.address.line3",
  senderState: "sender.address.countrySubdivisionCode",
  senderCity: "sender.address.city",
  senderCountryCode: "sender.address.countryCode",
  senderPostalCode: "sender.address.postalCode",
} as const;

/** API `field` tags in display order (filter by `mapiTransactionFieldsData.fieldInfo`). */
export const mapiSenderAddressFieldDisplayOrder: readonly string[] = [
  mapiSenderAddressFields.senderAddressline1,
  mapiSenderAddressFields.senderAddressline2,
  mapiSenderAddressFields.senderAddressline3,
  mapiSenderAddressFields.senderCity,
  mapiSenderAddressFields.senderPostalCode,
  mapiSenderAddressFields.senderState,
  mapiSenderAddressFields.senderCountryCode,
];
